/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExcelPlanResponse } from '../models/ExcelPlanResponse';
import type { GenerateExcelPreviewResponse } from '../models/GenerateExcelPreviewResponse';
import type { GenerateExcelRequest } from '../models/GenerateExcelRequest';
import type { GenerateExcelResponse } from '../models/GenerateExcelResponse';
import type { InferredMasterOverrideRequest } from '../models/InferredMasterOverrideRequest';
import type { InferredMasterResponse } from '../models/InferredMasterResponse';
import type { OptimizePlanRequest } from '../models/OptimizePlanRequest';
import type { OptimizePlanResponse } from '../models/OptimizePlanResponse';
import type { PlanKpiRequest } from '../models/PlanKpiRequest';
import type { PlanKpiResponse } from '../models/PlanKpiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductionPlanService {
    /**
     * 選択中ファイルからの生産計画作成
     * 選択中のファイルから生産計画を作成するエンドポイント
     * @param force セッション中の生産計画を破棄
     * @returns ExcelPlanResponse Successful Response
     * @throws ApiError
     */
    public static createProductionPlan(
        force?: number,
    ): CancelablePromise<ExcelPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-plan/selected',
            query: {
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Optimize
     * planを送信すると在庫とcapacityを計算して返すエンドポイント
     * @param requestBody
     * @returns OptimizePlanResponse Successful Response
     * @throws ApiError
     */
    public static optimize(
        requestBody: OptimizePlanRequest,
    ): CancelablePromise<OptimizePlanResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/optimize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 計画の評価表
     * 計画 (タスクの列) を、セッションの顧客ブックの在庫計算と推定マスタで評価する (比較パネル用)
     * @param requestBody
     * @returns PlanKpiResponse Successful Response
     * @throws ApiError
     */
    public static planKpi(
        requestBody: PlanKpiRequest,
    ): CancelablePromise<PlanKpiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/kpi',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 推定マスタ (前提の確認)
     * セッションのブックと過去の計画から、品目ごとの状態・ランク・機械・1日標準数などを推定して根拠付きで返す
     * @param start 計画の最初の日 (YYYY-MM-DD)
     * @param end 計画の最後の日 (省略時は start + 60日)
     * @returns InferredMasterResponse Successful Response
     * @throws ApiError
     */
    public static getInferredMaster(
        start: string,
        end?: (string | null),
    ): CancelablePromise<InferredMasterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-plan/inferred-master',
            query: {
                'start': start,
                'end': end,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 推定マスタの上書き
     * 品目の状態 (生産する / 作らない)・ランク・丸め単位を上書きする。clear に挙げた項目は上書きを外す(品番に # を含むので、品番はパスではなく本文で渡す)
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static putInferredMasterOverride(
        requestBody: InferredMasterOverrideRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/production-plan/inferred-master/override',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Excelファイルに保存したときの差分
     * 保存したら変わるセル (旧値 → 新値) と、書かない計画を返す。ブックは変更しない
     * @param requestBody
     * @returns GenerateExcelPreviewResponse Successful Response
     * @throws ApiError
     */
    public static previewExcel(
        requestBody: GenerateExcelRequest,
    ): CancelablePromise<GenerateExcelPreviewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/generate-excel/preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 生産計画Excelファイル生成
     * 選択中のExcelファイルを基に生産計画データを書き込み、ダウンロードURLを返します
     * @param requestBody
     * @returns GenerateExcelResponse Successful Response
     * @throws ApiError
     */
    public static generateExcel(
        requestBody: GenerateExcelRequest,
    ): CancelablePromise<GenerateExcelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/generate-excel',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
